export default __webpack_public_path__ + "static/media/2.823eea81.webp";